import api from "../utils/api";
import { isGuid } from "../utils/string";
import {
  LOGOUT
} from "./types";


export const get = ({ uuid, target }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.get(`/logs/i/${uuid}`) : await api.get(`/logs/t/${target}`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return { success: false, items: [] };
    }
}

export const save = ({ uuid, target, code, category, meta, authorUuid }) => async (dispatch) => {
    try {
        const res = await api.post(`/logs`, { uuid, target, code, category, meta, authorUuid });
        return res.data;
    } catch (error) {
        dispatch({
            type: LOGOUT
        });
    }
}
